<template>
  <div>
    <div id="overlay"  v-if="loading">
    <div class="spinner"></div>
    <br/>
      <h4>Loading...</h4>
    </div>
        <form class="form-horizontal">
          <div class="p-grid">
            <div class="p-col">
              <Button class="p-button-raised p-button-rounded" @click.prevent="openCommisionDialog" style="float: right"
              icon="pi pi-plus"/>
            </div>
          </div>
              <!-- <i class="pi pi-plus-circle"></i> -->
            <Dialog header="Commision Setup" :visible.sync="commisionSetup"
             :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">

            <!-- <form class="form-horizontal"> -->
            <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-4">
                <label for="commisionName" style="font-size:12px">Commision Name
                 <span style="color:red">*</span>
                 </label>
                <InputText  ref="name" v-model.trim="commissionName"/>
              </div>
               <div class="p-field p-col-4">
                 <label for="qtyFrom" style="font-size:12px">Quantity From<span style="color:red">*</span></label>
                 <InputText id="qtyFrom" v-model.trim="fromQty"/>
               </div>
               <div class="p-field p-col-4">
                 <label for="qtyTo" style="font-size:12px">Quantity To<span style="color:red">*</span></label>
                 <InputText id="qtyTo" v-model.trim="toQty"/>
               </div>
            </div>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-4">
                <label for="commisionType" style="font-size:12px">Commision Type
                 <span style="color:red">*</span>
                 </label>
                 <div class="p-field-radiobutton">
                  <RadioButton id="commision1" name="CommisionType" value="Flat" v-model="commisionType"/>
                  <label for="commision1">Flat</label>
                </div>
                <div class="p-field-radiobutton">
                  <RadioButton id="commision2" name="Percent" value="Percent" v-model="commisionType"/>
                  <label for="commision2">Percentage</label>
               </div>
                <InputText v-model="commissionFlat" v-if="commisionType==='Flat'" placeholder="Flat"/>
                <InputText v-model="commissionPercentage" v-if="commisionType==='Percent'" placeholder="Percent"/>
              </div>
            </div>
            <!-- </form> -->
          <template #footer>
            <Button class="p-button-raised p-button-rounded" :label="editing?'Update':'Add'" @click.prevent="addCommission"/>
            <Button class="p-button-raised p-button-info" v-if="!editing" label="Add & New"/>
            <Button  class="p-button-raised p-button-danger" label="Cancel" @click.prevent="cancel"/>
          </template>
        </Dialog>
        </form>
    </div>
    </template>
    <script>
    import RadioButton from 'primevue/radiobutton'
    import Dialog from 'primevue/dialog'
    import Button from 'primevue/button'
    import InputText from 'primevue/inputtext'

    export default {
      name: 'commisionSetup',
      data() {
        return {
          commisionSetup: false,
          editing: false,
          commissionName: '',
          loading: false,
          fromQty: null,
          toQty: null,
          commisionType: '',
          commissionPercentage: null,
          commissionFlat: null,
          id: null
        }
      },
      methods: {
        async addCommission() {
          if (this.commissionName === '') {
            this.$toast.add({severity: 'warn', summary: '', detail: 'Commision name cannot be empty!', life: 10000})
            return
          }
          if (this.fromQty < 0 || this.toQty <= 0) {
            this.$toast.add({severity: 'warn', summary: '', detail: 'Quantity cannot be less than equal to 0!', life: 10000})
            return
          }
          let response = ''
          let commision = {
            commissionName: this.commissionName,
            fromQty: this.fromQty,
            toQty: this.toQty,
            commissionPercentage: this.commissionPercentage,
            commissionFlat: this.commissionFlat,
            type: this.commisionType,
            id: this.id
          }
          if (!this.editing) {
            response = await this.$store.dispatch('addCommission', commision)
          } else {
            response = await this.$store.dispatch('updateCommission', commision)
          }
          this.reponseCheck(response)
        },
        async saveAndNewAccountGroup() {
        },
        reponseCheck(response) {
          if (response.data.status === 'SUCCESS') {
            this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
            this.closeCommisionDialog()
          }
        },
        cancel() {
          this.commisionSetup = !this.commisionSetup
          this.editing = false
          this.reset()
        },
        reset() {
          this.commissionName = ''
          this.fromQty = null
          this.toQty = null
          this.commissionPercentage = null
          this.commissionFlat = null
          this.commisionType = ''
        },
        openCommisionSetup(data) {
          this.editing = true
          this.commissionName = data.commissionName
          this.fromQty = data.fromQty
          this.toQty = data.toQty
          this.commissionPercentage = data.commissionPercentage
          this.commissionFlat = data.commissionFlat
          this.commisionType = data.type
          this.id = data.id
          this.openCommisionDialog()
        },
        focusAfterSave() {
          this.$refs.name.focus()
        },
        openCommisionDialog() {
          this.commisionSetup = true
        },
        closeCommisionDialog() {
          this.reset()
          this.commisionSetup = !this.commisionSetup
        }
      },
      components: {
        Dialog,
        RadioButton,
        Button,
        InputText
        // Toast
      }
    }
  </script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// commisionSetup.vue?9c83e80c